import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router';

import getUrl from '@/routes/routes/helpers/getUrl';
import NotificationIcon from '@/shared/NotificationCenter/NotificationIcon';
import { userProfileShape } from '../../../../proptypes';
import Avatar from '../../../Avatar';
import ButtonDropdown from '../../../../containers/ButtonDropdown';

import { hideBelowMD } from '../../../../base-styles/mixins.module.css';
import { avatar, button, container, signOut } from './styles.module.css';

export const UserMenuLoggedIn = ({ className, profile, router }) => (
  <>
    <NotificationIcon />
    <div className={className}>
      <div className={container}>
        {profile && (
          <Avatar
            user={profile}
            className={avatar}
            small
            trackingSource="user_menu"
          />
        )}
        <ButtonDropdown
          onClick={() => router.push(getUrl.privateProfile())}
          className={button}
          buttonVisible={false}
          dropdownDirection={['upSM', 'downLeftMD']}
          label="User actions"
        >
          <Link to={getUrl.privateProfile()} className={hideBelowMD}>
            Profile
          </Link>
          <Link to={getUrl.privateProfileSettings()} className={hideBelowMD}>
            Settings
          </Link>
          <Link to={getUrl.myEvents()} className={hideBelowMD}>
            Bookings
          </Link>
          <Link className={hideBelowMD} to={getUrl.groupPage()}>
            Groups
          </Link>
          <Link to={getUrl.savedEvents()} className={hideBelowMD}>
            Saved Events
          </Link>
          <Link to="/logout" className={signOut}>
            Log Out
          </Link>
        </ButtonDropdown>
      </div>
    </div>
  </>
);

UserMenuLoggedIn.propTypes = {
  /**
   * String class names to append to component styles.
   */
  className: PropTypes.string,
  /**
   * Normalized user profile object, when user is logged in
   */
  profile: userProfileShape,
  /**
   * Router object.
   */
  router: PropTypes.shape().isRequired,
};

UserMenuLoggedIn.defaultProps = {
  className: '',
  profile: null,
};

const UserMenuLoggedInWithRouter = withRouter(UserMenuLoggedIn);

export default UserMenuLoggedInWithRouter;
